@import "'~video.js/dist/video-js.min.css";
content-video {
  display: block;
  width: 100%;
  position: relative;
  // &.hydrated {
  //   height: 100%;
  //   &.content-video--fit-container {
  //     .video-js.vjs-fluid {
  //       height: 100%;
  //       padding: 0; // remove padding aspect ratio hack
  //     }
  //   }
  // }

  &.content-video--fit-container {
    .video-js.vjs-fluid {
      height: 100%;
      padding: 0; // remove padding aspect ratio hack
    }
  }
  
  &[fit-container='true'] {
    height: 100%;
  }

  .content-video__content {
    display: block;
    width: 100%;
    height: 100%;
  }

  .content-video__poster {
    position: relative;
  }
  .content-video__play {
    display: none;
  }
  // .content-video__play {
  //   cursor: pointer;
  //   appearance: none;
  //   border: none;
  //   background: transparent;
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   z-index: 1;

  //   &:before {
  //     content: '\25BA';
  //     font-size: 100px;
  //   }
  // }

  .vjs-content-block-theme {
    &.video-js {
      width: 100%;
      height: 100%;

      video.vjs-tech {
        position: static;
      }
    }
    &.vjs-ended,
    &.vjs-waiting {
      .vjs-loading-spinner {
        display: none;
      }
    }
    &:hover,
    &:focus {
      &:not(:focus-visible) {
        // background: transparent;
      }
      .vjs-big-play-button {
        background-color: transparent;
      }
    }
    .vjs-big-play-button {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border: none;
      background: transparent;
      .vjs-icon-placeholder {
        display: block;
        width: 100%;
        height: 100%;
        &:before {
          display: none;
        }
      }
    }
  }

  .vjs-poster {
    display: none;
  }
}
